import { Component, Output, EventEmitter, Input, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BaseFilterItemDirective } from './base-filter-item.directive';
import { BaseDialogActionData, ButtonColor, CommonActionKey } from '../base-dialog/base-dialog.model';

@UntilDestroy()
@Component({
    selector: 'ifc-base-filter-dialog',
    templateUrl: './base-filter-dialog.component.html',
    styleUrls: ['./base-filter-dialog.component.scss'],
    providers: [{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } }],
    standalone: false
})
export class BaseFilterDialogComponent implements AfterContentInit {
  @ContentChildren(BaseFilterItemDirective, { descendants: false }) items: QueryList<BaseFilterItemDirective>;

  @Input()
  form: FormGroup;

  @Output()
  confirmed = new EventEmitter();

  isSingle = false;

  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Cancel, label: 'Cancel', buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Ok, label: 'OK', buttonColor: ButtonColor.Primary, initialFocus: true },
  ];

  constructor(private readonly dialogRef: MatDialogRef<BaseFilterDialogComponent>) {}

  ngAfterContentInit(): void {
    this.isSingle = this.items?.length === 1;
    this.items.changes.pipe(untilDestroyed(this)).subscribe(() => (this.isSingle = this.items.length === 1));
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey === CommonActionKey.Ok) {
      this.confirmed.emit(this.form.value);
      return;
    }
    this.dialogRef.close();
  }
}
